// removed by extract-text-webpack-plugin
module.exports = {"directions":"Directions-directions","header":"Directions-header","list":"Directions-list","direction":"Directions-direction","link":"Directions-link","codeName":"Directions-codeName"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Directions/index.css
// module id = 1709
// module chunks = 0